module.exports = __webpack_public_path__ + "static/media/f3.3ea7d293.jpg";